// const BASE_URL = 'http://192.168.1.132:93/api/'; // TEST
// const BASE_URL = 'http://115.113.146.197:200/api/';   // UAT - public ip
// const BASE_URL = 'http://192.168.1.132:200/';   // UAT - Internal

// const BASE_URL = 'http://localhost:49909/api/'; // LOCAL
// const BASE_URL = '/api/'; // GLOBAL
let BASE_URL =''
if(window.location.href.indexOf('localhost') !== -1){
    BASE_URL ='http://localhost:5000/api/';
}
else {
    BASE_URL = '/api/';
}
export const REGISTER = BASE_URL + 'users';
export const LOGIN = BASE_URL + 'users/authenticate';
export const LOGIN_AD = BASE_URL + 'users/authenticate-ad';
export const CAPTCHA_VERIFICATION = BASE_URL + 'users/verifycaptcha';
export const GET_ALL_COUNTRIES = BASE_URL + 'countries/getallcountries';
export const GET_ALL_COUNTRIES_BY_REGION = BASE_URL + 'countries/getallcountriesbyregion';
export const MODULE_BASE = BASE_URL + 'modules';
export const USER_LIST = BASE_URL + 'users';
export const COUNTRY_LIST = BASE_URL + 'countries';
export const ROLE_LIST = BASE_URL + 'users/roles';
export const REGION_LIST = BASE_URL + 'countries/regions';
export const SURVEY_BASE = BASE_URL + 'surveys';
export const SURVEY_BASE_DASHBOARD = BASE_URL + 'surveys/getsurveylistdashboard';
export const EDIT_SURVEY_API = BASE_URL + 'surveys/getsurveydetailsbyid';
export const CHECK_QUESTION_STATUS_API = BASE_URL + 'surveys/CheckQuestionStatus'; 
export const PUBLISH_SURVEY = BASE_URL + 'surveys/publishsurvey';
export const UPDATE_SURVEY_DATE_API = BASE_URL + 'surveys/updatesurveyenddate';
export const DELETE_SURVEY_API = BASE_URL + 'surveys/';
export const PENDING_USER_LIST = BASE_URL + 'users/pending';
export const UPDATE_PENDING_USER_LIST = BASE_URL + 'users/approverejectuser/';
export const SHARE_LINK = BASE_URL + 'users/sendInviteEmail';
export const MODULE_QUESTIONS_SAVE = BASE_URL + 'questions/add/';
export const REJECTED_USER_LIST = BASE_URL + 'users/rejected';
export const RESPONSE_BASE = BASE_URL + 'responses';
export const DELETE_MODULE_API = BASE_URL + 'modules/delete/';
export const DASHBOARD = BASE_URL + 'modules/GetModuleSurvey';
export const MODULE_QUESTIONS = BASE_URL + 'modules/Questions';
export const DELETE_QUESTION_MODULE = BASE_URL + 'questions/delete';
export const COLLABORATION_LIST = BASE_URL + 'collaborations';
export const QUESTION_VERSION = BASE_URL + 'questions/versions';
export const SUBMIT_SURVYE_RESPONSE = BASE_URL + 'summary/submitsummary/';
export const ADMINDASHBOARD = BASE_URL + 'surveys/hqAdminDashboard';
export const REGIONALADMINDASHBOARD = BASE_URL + 'surveys/regionalAdminDashboard';
export const SYSTEM_NOTIFICATION_LIST = BASE_URL + 'notifications/system-notification';
export const SAVE_REMINDER_CONFIG = BASE_URL + 'notifications/reminder';
export const SYSTEM_NOTIFICATION_MARK_AS_READ = BASE_URL + 'notifications/system-notification/mark-as-read/';
export const SYSTEM_NOTIFICATION_CLEAR_ALL=BASE_URL+'notifications/system-notification/clear-all-notification/';
export const USER_ASSIGNED_COUNTRIES = BASE_URL + 'modules/getUserCountries';
export const UPDATE_USER_CURRENT_ACTIVE_COUNTRY = BASE_URL + 'modules/changeActiveCountry';
export const FORGOT_PASSWORD = BASE_URL + 'users/forgotpassword';
export const RESET_PASSWORD = BASE_URL + 'users/resetpassword';
export const COUNTRYMODULETYPEDASHBOARD = BASE_URL + 'surveys/getDashBoardModuleCategoryData';
export const DECRYPT_KEY = BASE_URL + 'users/decrypt';
export const GET_LAST_YEAR_RESPONSE = BASE_URL + 'responses/getlastyearresponse';
export const APP_SETTINGS = BASE_URL + 'users/app-settings';

export const GET_EXCEL_PROGRESS_REPORTS = BASE_URL + 'reports/progressReport';
export const GET_EXCEL_REPORTS = BASE_URL + 'reports/responseReport';

export const GET_ZIP_FOR_ALL_MODULES = BASE_URL + 'reports/responseReportZip';

export const GET_REMIDNER_SETTING = BASE_URL + 'surveys/getEmailNotificationSettingForDashboard/';
export const ASSIGN_COUNTRY_TO_USER = BASE_URL + 'users/assignCountryToUser/';
export const GET_MODULE_PDF = BASE_URL + 'reports/module/pdf/';
export const GET_MODULE_PDF_FN = BASE_URL + 'reports/module/PdfFn/';
export const GET_MODULE_PDF_SP = BASE_URL + 'reports/module/pdfSp/';
export const GET_WEBINAR_DOCUMENT = BASE_URL + 'reports/module/webinar/';

export const GET_OTHER_DOCUMENTS= BASE_URL + 'reports/survey/pdf/';

export const GET_SUMMARY_PAGE_PDF = BASE_URL + 'reports/summaryPagePdf/';

export const SYNC_OFFLINE_RESPONSE_API = BASE_URL + 'responses/syncofflinedata';
export const QUESTION_RAM_INTEGRATION = BASE_URL + 'questions/getRamIntegrationData';
export const QUESTION_APPROVE = BASE_URL + 'questions/approve';
export const QUESTION_REJECT = BASE_URL + 'questions/reject';
export const QUESTION_ASSIGN_CREATOR = BASE_URL + 'questions/assignToCreatorQuestion';
export const ADD_REVIEW_COMMENT = BASE_URL + 'questions/addQuestionReviewComment';
export const GET_REVIEW_COMMENTS = BASE_URL + 'questions/getQuestionReviewComment';
export const SYSTEM_NOTIFICATION_COUNT = BASE_URL + 'notifications/system-notifications-count';


// WEBPACK FOOTER //
// ./src/constants/api.tsx